<ion-header>
  <ion-toolbar>
    <ion-title>{{'components.job.modal-details.title' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="this.modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>

    <ion-card-header>
      <ion-card-title>{{'components.job.modal-details.label-classification-results' | translate}}</ion-card-title>
      <ion-button fill="clear" (click)="downloadCSV()">
        <ion-icon slot="start" name="download"></ion-icon>
        CSV
      </ion-button>
    </ion-card-header>
    <ion-card-content>
      <ion-item>{{'components.job.modal-details.label-class' | translate}} {{ 'crops.' + result.finalClass | translate}}</ion-item>
      <ion-item>{{'components.job.modal-details.label-confidence' | translate}} {{ result.maxPerc | percent }}</ion-item>

      @if (barChartData) {
        <div style="display: block">
          <canvas #chartCanvas baseChart (chartHover)="chartHovered($event)">
          </canvas>
        </div>
      }

      <!-- <ion-item *ngIf="result.feedback && result.feedback > 0">{{'components.job.modal-details.label-your-comment' | translate}} &nbsp; <i>{{ result.feedback }}</i>
    </ion-item> -->
    @if (imageData.datetime) {
      <ion-item>{{'components.job.modal-details.label-date-taken' | translate}} {{ imageData.datetime }}</ion-item>
    }
    <ion-item>{{'components.job.modal-details.label-name' | translate}} {{ imageData.name }}</ion-item>
    <!-- <ion-item>Klassenbeschreibung: {{ result.class_description }}</ion-item> -->
    @if (imageData.GPSLatitude && imageData.GPSLongitude) {
      <ion-item>{{'components.job.modal-details.label-position' | translate:imageData}}</ion-item>
    }

  </ion-card-content>
  @if (imageUrl) {
    <img [src]="imageUrl" (load)="loaded($event)">
  }
</ion-card>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      @if (result.imageId) {
        <ion-button color="secondary" expand="full" (click)="leaveFeedback()">
          {{'components.job.modal-details.btn-feedback' | translate}}
        </ion-button>
      }

      <ion-button color="primary" expand="full" (click)="this.modalCtrl.dismiss()">
        {{'shared.btn-close' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
